module.exports = __webpack_public_path__ + "img/1alB-l-lage'.2872cd68.jpg";